import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from './LanguageContext';
import translations from '../translations.json';
import './Stats.css';

interface ProgressBarProps {
  color: string;
  number: string | number;
  percent: string | number;
  name: string;
  description: string;
  type?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ color, number, percent, name, description, type = '' }) => {
  return (
    <Col md={4} className="pb-card progressbars">
      <div className="percent" style={{ '--clr': color, '--num': percent } as React.CSSProperties}>
        <div className="dot"></div>
        <svg>
          <circle cx="70" cy="70" r="70"></circle>
          <circle cx="70" cy="70" r="70"></circle>
        </svg>
        <div className="number">
          <h2>{number}{type === '%' && <span>%</span>}</h2>
        </div>
      </div>
      <h3>{name}</h3>
      <p>{description}</p>
    </Col>
  );
};

const Stats: React.FC = () => {
  const { language } = useLanguage();
  const t = translations[language]['stats'];

  return (
    <section className="stats">
      <Container className="vh-100 d-flex flex-column justify-content-center">
        <Row className="justify-content-center">
          <Col md={6} className="d-flex justify-content-center">
          <h1 dangerouslySetInnerHTML={{ __html: t.title }} />
          </Col>
        </Row>
        <Row className="justify-content-center">
          {t.stats.map((stat, index) => (
            <ProgressBar
              key={index}
              color={stat.color}
              number={stat.number}
              percent={stat.percent}
              name={stat.name}
              description={stat.description}
              type={stat.type}
            />
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Stats;
